var map = {
	"./01.jpg": "./src/assets/videoBackground/01.jpg",
	"./Foto_modulo_oficina_virtual.png": "./src/assets/videoBackground/Foto_modulo_oficina_virtual.png",
	"./fondo_ team_backing_Mesa_de_trabajo_1.png": "./src/assets/videoBackground/fondo_ team_backing_Mesa_de_trabajo_1.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/videoBackground sync recursive ^\\.\\/.*$";